import { render, staticRenderFns } from "./CommunityCitySanjae.vue?vue&type=template&id=62bcb692&scoped=true"
import script from "./CommunityCitySanjae.vue?vue&type=script&lang=js"
export * from "./CommunityCitySanjae.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bcb692",
  null
  
)

export default component.exports